import { FormControl, Validators, ValidatorFn, FormGroup } from '@angular/forms';
import moment from 'moment';

export class GlobalValidators {
    static validDateRange(beginDateControlName: string, endDateControlName: string): ValidatorFn {
        return (formGroup: FormGroup): { [key: string]: any } => {
            const beginControl = formGroup.controls[beginDateControlName];
            const endControl = formGroup.controls[endDateControlName];
            const beginDate = moment(beginControl.value);
            const endDate = moment(endControl.value);

            if (!beginDate.isValid() || !endDate.isValid()) return;

            if (beginDate.isSameOrAfter(endDate, 'day')) {
                endControl.setErrors({ dateRange: false });
                return { dateRange: false };
            }
        }
    }

    static dateBetween(beginDate: moment.Moment, endDate: moment.Moment, controlDateFormat: string): ValidatorFn {
        return (control: FormControl): { [key: string]: any } => {
            if (!control.value) return;
            const controlDate = moment(control.value, controlDateFormat);

            if (!controlDate.isValid() || !beginDate.isValid() || !endDate.isValid()) return;

            if (!controlDate.isBetween(beginDate.subtract("1", "days"), endDate.add("1", "days"))) {
                return { dateBetween: false };
            }
        }
    }

    static dateRangeMinEndDaysAfter(beginDateControlName: string, endDateControlName: string, daysAfterBeginDate: number): ValidatorFn {
        return (formGroup: FormGroup): { [key: string]: any } => {
            const beginControl = formGroup.controls[beginDateControlName];
            const endControl = formGroup.controls[endDateControlName];
            const beginDate = moment(beginControl.value);
            const endDate = moment(endControl.value);

            if (!beginDate.isValid() || !endDate.isValid()) return;

            if (endDate.isBefore(beginDate.add(daysAfterBeginDate, 'days'), 'day')) {
                endControl.setErrors({ dateRangeMinEndDaysAfter: false });
                return { dateRangeMinEndDaysAfter: false };
            }
        }
    }

    static dateRangeMaxEndYearsAfter(beginDateControlName: string, endDateControlName: string, yearsAfterBeginDate: number): ValidatorFn {
        return (formGroup: FormGroup): { [key: string]: any } => {
            const beginControl = formGroup.controls[beginDateControlName];
            const endControl = formGroup.controls[endDateControlName];
            const beginDate = moment(beginControl.value);
            const endDate = moment(endControl.value);

            if (!beginDate.isValid() || !endDate.isValid()) return;

            if (endDate.isAfter(beginDate.add(yearsAfterBeginDate, 'years'), 'day')) {
                endControl.setErrors({ dateRangeMaxEndYearsAfter: false });
                return { dateRangeMaxEndYearsAfter: false };
            }
        }
    }

    static gradDateMax(control: FormControl) {
        if (!control.value) return;

        const today = moment();
        const controlDate = moment(control.value);

        if (!controlDate.isValid() || !controlDate.isSameOrBefore(today, 'day')) {
            return { gradDateMax: false };
        }
    }

    static gradDateMin(control: FormControl) {
        if (!control.value) return;

        const minPastDate = moment("2000-01-01");
        const controlDate = moment(control.value);

        if (!controlDate.isValid() || !controlDate.isSameOrAfter(minPastDate, 'day')) {
            return { gradDateMin: false };
        }
    }

    static minDate(minDate: Date) {
        return function (control: FormControl) {
            if (!control.value) return;

            const controlDate = moment(control.value);

            if (!controlDate.isValid() || !controlDate.isSameOrAfter(minDate, 'day')) {
                return { minDate: false };
            }
        }
    }

    static validDate(dateFormat: string) {
        return function (control: FormControl) {
            if (!control.value) return;

            const controlDate = moment(control.value, dateFormat);

            if (!controlDate.isValid()) {
                return { validDate: false };
            }
        }
    }

    static maxDate(maxDate: Date) {
        return function (control: FormControl) {
            if (!control.value) return;

            const controlDate = moment(control.value);

            if (!controlDate.isValid() || !controlDate.isSameOrBefore(maxDate, 'day')) {
                return { maxDate: false };
            }
        }
    }

    static wholeNumbers(control: FormControl) {
        const number = Number(control.value);
        if (Number.isNaN(number) === false && (number % 1 !== 0)) {
            return { wholeNumbers: false };
        }

        return null;
    }
}